import { Component, OnInit, ElementRef, Input, ViewChild, TemplateRef, ViewChildren, QueryList, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IBrokerRegionalLicenses } from '../shared/models/BrokerRegionalLicensesInputModel';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { PropertiesAssociatedOutputModel } from '../shared/models/PropertiesAssociatedOutputModel'
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { IPropertySearchCriteria } from '../shared/models/propertysearchcriteria';
import { environment } from '../../environments/environment'
import { CurrencyPipe } from '@angular/common';
import { spaceOnlyValidator, ValidationService } from '../shared/providers/validation.service';
import { IPropertyAccessInputModel } from '../shared/models/PropertyAccessInputModel';
import { ToastService } from '../shared/providers/toast.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserRole, YesNo } from '../shared/enum/enum';
import { LoaderService } from '../shared/providers/loader.service';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { DashboardService } from '../shared/providers/dashboard.service';
import { IProspectUserListModel } from '../shared/models/ProspectUserListModel';
import { IBulkUpdatePropertyListModel } from '../shared/models/BulkUpdatePropertyListModel';
import { CommonService } from '../shared/providers/common.service';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IBulkUpdateModel } from '../shared/models/BulkUpdateModel';
import { ProspectModel } from '../shared/models/ProspectModel';
import { MatSelect } from '@angular/material/select';
import { PermissionService } from '../shared/providers/permission.service';
import { Actions, Modules } from '../shared/enum/enum';

enum Menus {
  LiveListings = 1,
  OffMarket = 2
}

@Component({
  selector: 'prospect-details',
  templateUrl: './prospect-details.component.html',
  styleUrls: ['./prospect-details.component.css']
})
export class ProspectDetailsComponent implements OnInit {

  protected readonly BASE_URL: string = environment.base_url;
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;
  emailForm: FormGroup;
  dtoptions = {};
  DDColumns = [];
  Modules = Modules;
  Actions = Actions;
  @Input() prospectId: number;
  @Input() source = '';
  @Input() principalDetails = {} as IUserDetails;
  prospectDetails = {} as IProspectUserListModel;
  prospectModel = {} as IBulkUpdateModel;
  prospectEditModel = {} as ProspectModel;
  updateEmailModel = {} as ProspectModel;
  propertyList: IBulkUpdatePropertyListModel[] = [];
  selectedLiveListings: IBulkUpdatePropertyListModel[] = [];
  selectedOffMarket: IBulkUpdatePropertyListModel[] = [];
  menu = Menus;
  activeMenu = Menus.LiveListings;
  user: any;
  prospectUserId: number = 0;
  selectedCheckboxDataLimit: number = 5;
  IsSelectedPropertyOpened: boolean = false;
  IsEditMode: boolean = false;
  modalRef: BsModalRef;
  statusList: ILookUp[];
  prospectForm: FormGroup;
  IspropertyOpened: boolean = false;
  OpenedDetails: number = 0;
  showHeader = true;
  prospectEditForm: FormGroup;
  prospectEditProperty: string = '';
  prospectEditLocation: string = '';
  prevPage = "External Users";
  prevPageRouteLink = "users/registered-users";
  emailValid: boolean = true;
  emailvalidation: string = "";
  userEmailAddress: string = "";
  enableEmailEditField: boolean = false;
  feedackList: any[];
  IsDataProcessing: boolean = false;
  //defaultText: IMultiSelectTexts = {
  //  defaultTitle: 'Select',
  //};
  defaultSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };

  constructor(private propertyListing: PropertyListingService, private renderer: Renderer2, public permissionService: PermissionService,
    private _commonService: CommonService, private _dashboardService: DashboardService, private _userManagerService: UserManagerService, private Loader: LoaderService, private activatedRoute: ActivatedRoute, private _authenticationService: AuthenticationService, private router: Router, private http: HttpClient, public _validationService: ValidationService, private _toastService: ToastService, private modalService: BsModalService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.prospectUserId = params['prospectId'];
      let previousRoute = params['prevroute'];
      let previousPage = params['link'];
      if (previousRoute !== null && previousRoute !== undefined) {
        this.prevPage = previousRoute;
      }
      if (previousPage !== null && previousPage !== undefined) {
        this.prevPageRouteLink = previousPage;
      }
    });
  }

  User: any;
  ShowbrokerRegionalLicenses = false;
  IsSeller = false;
  ngOnInit() {
    if (this.source == "prinicipal-details") {
      this.showHeader = false;
      if (this.prospectUserId != null && this.prospectUserId > 0) {
        this.prospectUserId = this.prospectId;
      }
    }
    else {
      this.getProspectUserDetails();
      this.emailForm = new FormGroup({
        'emailinput': new FormControl(this.userEmailAddress, [
          Validators.required,
          spaceOnlyValidator
        ]),
      });
    }
    this.user = this._authenticationService.user;
    this.Loader.display(true);
    this.getProperties();
  }

  addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }

  removeClassFromOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.removeClass(overlayContainer, 'custom-overlay-container');
    }
  }

  get emailinput() { return this.emailForm.get('emailinput'); }

  getProperties() {
    this.DDColumns = [
      { data: 'IsSelected' },
      { data: 'IsSelected' },
      { data: 'PropertyName' },
      { data: 'PropertyName' },
      { data: 'Status' },
      { data: 'OMDownloads' },
      { data: 'NDAExecuted' },
      { data: 'Notes' },
      { data: 'Id' }
    ];

    const that = this;
    this.dtoptions = {
      pagingType: 'full_numbers',
      "pageLength": 20,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[2, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsDataProcessing = true;
        let currentPropertyList = that.selectedLiveListings.length > 0 ? that.selectedLiveListings.map(i => i.Id) : [];
        dataTablesParameters.Extra_param = {
          UserId: that.user.Id,
          PropertyStatusId: that.activeMenu == that.menu.LiveListings ? 351 : 356,
          ProspectUserId: this.prospectUserId != null && this.prospectUserId > 0 ? this.prospectUserId : 0,
          PropertyLst: currentPropertyList,
          RegisteredUserId: this.principalDetails != null ? this.principalDetails.Id : 0
        }
        const httpHeader = this._validationService.GetAuthHeader();
        this.IsSelectedPropertyOpened = false;
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/property/GetBulkAddPropertyList', dataTablesParameters, httpHeader).subscribe(resp => {
            if (resp != null) {
              that.propertyList = resp.data ? resp.data : [];
              this.autoSelectProperties();
              this.Loader.display(false);
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data == null || resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsDataProcessing = false;
          });

        this.Loader.display(false);
      },
      columns: this.DDColumns
    };
  }

  onTabClick(selectedTab) {
    this.activeMenu = selectedTab;
    this.selectedLiveListings = [];
    this.selectAll = false;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  getProspectUserDetails() {
    this._userManagerService.getProspectUserDetails(this.prospectUserId.toString()).subscribe(response => {
      this.prospectDetails = response;
    });
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  selectAll = false;
  onCheckboxChange(event, Id) {
    if (event.target.checked) {
      let prop = this.propertyList.find(x => x.Id == Id);
      this.selectedLiveListings.push(prop);
    }
    else {
      this.selectedLiveListings.splice(this.selectedLiveListings.findIndex(x => x.Id == Id), 1);
    }
    this.autoSelectAll();
  }

  autoSelectAll() {
    if (this.propertyList.filter(x => x.IsSelected == true).length == this.propertyList.length && this.propertyList.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }

  onSelectedPropertyRemove(propertyId: number) {
    this.selectedLiveListings.splice(this.selectedLiveListings.findIndex(x => x.Id == propertyId), 1);
    this.selectAll = false;
    let currentItem = this.propertyList.find(f => f.Id == propertyId);
    if (currentItem != null) {
      currentItem.IsSelected = false;
    }
  }

  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.propertyList.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        if (this.selectedLiveListings.findIndex(x => x.Id == item.Id) < 0) {
          this.selectedLiveListings.push(item);
        }
      }
      else {
        this.selectedLiveListings.splice(this.selectedLiveListings.findIndex(x => x.Id == item.Id), 1);
      }
    });
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  autoSelectProperties() {
    if (this.propertyList != null && this.propertyList.length > 0) {
      if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
        this.propertyList.forEach(item => {
          if (this.selectedLiveListings.findIndex(f => f.Id == item.Id) > -1) {
            item.IsSelected = true;
          }
        });
      }

      if (this.propertyList.findIndex(f => !f.IsSelected) > -1) {
        this.selectAll = false;
      }
      else {
        this.selectAll = true;
      }
    }
  }

  onViewAllProperties() {
    this.IsSelectedPropertyOpened = true;
  }

  addFeedBack() {
    this.matSelects.forEach((matSelect) => {
      matSelect.openedChange.subscribe((isOpened) => {
        if (isOpened) {
          this.addClassToOverlayContainer();
        } else {
          this.removeClassFromOverlayContainer();
        }
      });
    });
  }

  get lstStatus() { return this.prospectForm.get('lstStatus'); }
  get txtNotes() { return this.prospectForm.get('txtNotes'); }
  get BulkchkOMDownloads() { return this.prospectForm.get('BulkchkOMDownloads'); }
  get BulkchkNDAExecuted() { return this.prospectForm.get('BulkchkNDAExecuted'); }
  get lstFeedback() { return this.prospectForm.get('lstFeedback'); }

  bulkUpdateProperties(template: TemplateRef<any>, classes, Id = 0) {
    this.addFeedBack();
    let emailId = '';
    if (this.source == "prinicipal-details") {
      if (this.principalDetails != null && this.principalDetails != undefined) {
        emailId = this.principalDetails.Email != null && this.principalDetails.Email != '' ? this.principalDetails.Email : '';
      }
    }
    else {
      if (this.prospectDetails != null && this.prospectDetails.Email != '') {
        emailId = this.prospectDetails.Email != null && this.prospectDetails.Email != '' ? this.prospectDetails.Email : '';
      }
    }
    if (emailId != null && emailId != '') {
      if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
        this.loadStatus();
        this.getFeedBackList();
        this.resetBulkUpdateModel();
        this.prospectForm = new FormGroup({
          'txtNotes': new FormControl(this.prospectModel.Notes),
          'lstStatus': new FormControl(this.prospectModel.ProspectStatusId, [
            Validators.required
          ]),
          'BulkchkOMDownloads': new FormControl(this.prospectModel.OMDownloads),
          'BulkchkNDAExecuted': new FormControl(this.prospectModel.NDAExecuted),
          'lstFeedback': new FormControl(this.prospectModel.Feedback)
        });
        this.modalRef = this.modalService.show(template, { class: classes });
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: "Please select the Properties.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    }
    else {
      this.enableEmailEditField = true;
      this._toastService.addToast({ title: 'Error', msg: "Please update Prospect's Email ID.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      var element = document.getElementById("prospect-phn-number");
      this.scrollToBottom(element, 790);
      //  document.getElementById('input_prospect_email').focus();
    }
  }
  scrollToBottom(element, offset) {
    $('html,body').animate({ scrollTop: ($(element).offset().top + -100) }, 500);
  }

  onClose() {
    this.modalRef.hide();
  }

  loadStatus() {
    this._commonService.getLookupsByTypeId(44).subscribe(response => {
      this.statusList = response.map(o => {
        return {
          id: o.Id, description: o.Description, typeid: o.TypeId
        };
      });
    });
  }

  bulkUpdateProspects() {
    this.Loader.display(true);
    if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
      this.prospectModel.LoggedInUserId = this.user.Id;
      this.prospectModel.ProspectUserId = this.prospectUserId != null ? this.prospectUserId : 0;
      this.prospectModel.RegisteredUserId = this.principalDetails != null ? this.principalDetails.Id : 0
      this.prospectModel.PropertyIds = this.selectedLiveListings.map(i => i.Id);
      if (this.prospectModel.PropertyIds != null && this.prospectModel.PropertyIds.length > 0) {
        if (this.prospectModel.ProspectStatusId != null && this.prospectModel.ProspectStatusId > 0) {
          if (this.prospectForm.valid) {
            this._dashboardService.saveBulkUpdate(this.prospectModel).subscribe(item => {
              if (item != null && item != '') {
                this.Loader.display(false);
                this.modalRef.hide();
                this.selectedLiveListings = [];
                this.dtElement.dtInstance.then(x => x.draw());
                this._toastService.addToast({ title: 'Success', msg: "Bulk update saved successfully.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
              }
              else {
                this.Loader.display(false);
                this.modalRef.hide();
                this._toastService.addToast({ title: 'Error', msg: "Something went wrong.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
              }
            });
          }
        }
        else {
          this.Loader.display(false);
          this._toastService.addToast({ title: 'Error', msg: "Please select the Status.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      }
      else {
        this.Loader.display(false);
        this._toastService.addToast({ title: 'Error', msg: "Please select the Properties.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    }
    else {
      this.Loader.display(false);
      this._toastService.addToast({ title: 'Error', msg: "Please select the Properties.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
  }

  removeProperty(propertyId: number) {
    if (this.selectedLiveListings.findIndex(f => f.Id == propertyId) > -1) {
      this.selectedLiveListings.splice(this.selectedLiveListings.findIndex(x => x.Id == propertyId), 1);
    }
  }

  showFullProperties() {
    this.IspropertyOpened = this.IspropertyOpened ? false : true;
    this.OpenedDetails = this.IspropertyOpened == true ? 1 : 0;
    if (this.IspropertyOpened) {
      $('div#BulkUpdateDiv').removeClass('active');
    }
    else {
      $('div#BulkUpdateDiv').addClass('active');
    }
  }

  clearAllSelections() {
    this.matSelects.toArray().forEach(select => {
      select.value = null;  // Clear the value of each MatSelect
    });
  }
  getProspectDetails(template: TemplateRef<any>, classes, currentprospectId?: number, Id?: number, IsPortfolio?: boolean) {
    let emailId = '';
    if (this.source == "prinicipal-details") {
      if (this.principalDetails != null && this.principalDetails != undefined) {
        emailId = this.principalDetails.Email != null && this.principalDetails.Email != '' ? this.principalDetails.Email : '';
      }
    }
    else {
      if (this.prospectDetails != null && this.prospectDetails.Email != '') {
        emailId = this.prospectDetails.Email != null && this.prospectDetails.Email != '' ? this.prospectDetails.Email : '';
      }
    }
    if (emailId != null && emailId != '') {
      this.resetModel();
      this.clearAllSelections();
      this.prospectEditModel.Feedback = [];
      this.prospectEditModel.FeedBackId = '';
      if (currentprospectId != null && currentprospectId > 0) {
        this._dashboardService.GetProspectDetails(currentprospectId).subscribe(res => {
          this.prospectEditModel = res[0];
          if (this.prospectEditModel != null && this.prospectEditModel.FeedBackId != null && this.prospectEditModel.FeedBackId != '') {
            this.prospectEditModel.Feedback = this.prospectEditModel.FeedBackId.split(',').map(i => parseInt(i));
          }
        });
      }
      if (Id != null && this.propertyList.findIndex(i => i.Id == Id) > -1) {
        let currentPropety = this.propertyList.find(i => i.Id == Id);
        this.prospectEditProperty = currentPropety != null ? currentPropety.PropertyName : '';
        this.prospectEditLocation = currentPropety != null && currentPropety.City != null ?
          currentPropety.City + ', ' + currentPropety.State : '';

      }
      this.prospectEditModel.PropertyId = Id;
      this.prospectEditModel.ProspectUserId = this.prospectUserId;
      this.getFeedBackList();
      if (this.statusList == null || this.statusList.length <= 0) {
        this.loadStatus();
      }
      this.prospectEditModel.OfferOnId = IsPortfolio ? 6002 : 6001;
      this.openEditModel(template, classes);
    }
    else {
      this._toastService.addToast({ title: 'Error', msg: "Please update Prospect's Email ID.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      this.enableEmailEditField = true;
      var element = document.getElementById("prospect-phn-number");
      this.scrollToBottom(element, 790);
    }

  }

  get chkOMDownloads() { return this.prospectForm.get('chkOMDownloads'); }
  get chkNDAExecuted() { return this.prospectForm.get('chkNDAExecuted'); }
  get edittxtNotes() { return this.prospectForm.get('edittxtNotes'); }
  get editlstStatus() { return this.prospectForm.get('editlstStatus'); }
  get editlstFeedback() { return this.prospectForm.get('editlstFeedback'); }
  openEditModel(template: TemplateRef<any>, classes) {
    this.prospectEditForm = new FormGroup({
      'chkOMDownloads': new FormControl(this.prospectEditModel.OMDownloads),
      'chkNDAExecuted': new FormControl(this.prospectEditModel.NDAExecuted),
      'edittxtNotes': new FormControl(this.prospectEditModel.Notes),
      'editlstStatus': new FormControl(this.prospectEditModel.Status),
      'editlstFeedback': new FormControl(this.prospectEditModel.Feedback)
    });
    this.modalRef = this.modalService.show(template, { class: classes });
    this.addFeedBack();
  }

  saveDetails() {
    if (this.prospectEditForm.valid) {
      let allowSaveEdit = true;
      if (this.prospectEditModel.PropertyId == null || this.prospectEditModel.PropertyId == 0) {
        allowSaveEdit = false
      }
      if (this.prospectEditModel.Status == null || this.prospectEditModel.Status == 0) {
        allowSaveEdit = false;
      }
      if (allowSaveEdit) {
        this.prospectEditModel.CreatedBy = this.user.Id;
        this.prospectEditModel.CreatedDate = this._validationService.utcify(new Date());

        if (this.prospectEditModel.Status != 5007) {
          this.prospectEditModel.Feedback = null;
        }

        this.prospectEditModel.IsSFSubject = false;
        if (this.statusList.find(x => x.id == this.prospectEditModel.Status).typeid == 0) {
          this.prospectEditModel.IsSFSubject = true;
        }
        this.prospectEditModel.AllowSave = true;
        this.Loader.display(true);
        if (this.prospectUserId == 0 || this.prospectUserId == null) {
          this.prospectEditModel.Email = this.principalDetails.Email;
          this.prospectEditModel.FirstName = this.principalDetails.FirstName;
          this.prospectEditModel.LastName = this.principalDetails.LastName;
        }
        this.prospectEditModel.ProspectUserId = this.prospectUserId;
        let model = this.prospectEditModel;
        model.Id = 0;
        this._dashboardService.saveProspects(model).subscribe(item => {
          this.Loader.display(false);
          this.modalRef.hide();
          this.dtElement.dtInstance.then(x => x.draw());
          this.selectedLiveListings = [];
          if (this.propertyList.findIndex(f => f.Id == this.prospectEditModel.PropertyId) > -1) {
            this.propertyList.find(f => f.Id == this.prospectEditModel.PropertyId).IsSelected = false;
          }
          this._toastService.addToast({ title: 'Success', msg: "Prospects saved successfully.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        });
      }
      else {
        this.Loader.display(false);
        this._toastService.addToast({ title: 'Error', msg: "Please enter the mandatory fields.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    }
  }

  resetModel() {
    this.prospectEditModel = {
      CompanyName: "",
      ProspectName: "",
      PropertyId: null,
      NDAExecuted: false,
      OMDownloads: false,
      Feedback: null,
      Id: 0,
      InquiryId: null,
      LeadDetailId: null,
      Notes: "",
      OfferOnId: 6001,
      Status: null,
      LstDocuments: [],
      IsCheckboxUpdate: false,
      PCount: 0,
      PrevEntry: [],
      showPrevEntries: false,
      ShortDescription: "",
      FirstName: "",
      LastName: "",
      Email: "",
      AccountName: "",
      Phone: ""
    }
  }
  resetBulkUpdateModel() {
    this.prospectModel = {
      ProspectStatusId: null,
      Notes: "",
      LoggedInUserId: 0,
      PropertyIds: [],
      ProspectUserId: 0,
      OMDownloads: false,
      NDAExecuted: false
    }
  }
  onBreadCrumbClick() {
    if (this.prevPage == 'Prospects') {
      let url = this.prevPageRouteLink + '?userTab=Prospects';
      this.router.navigateByUrl(url);
    }
    else {
      this.router.navigateByUrl(this.prevPageRouteLink);
    }
  }

  validateemail() {
    if ((this._validationService.isEmail(this.userEmailAddress) == false) && !this._validationService.IsinValid(this.userEmailAddress)) {
      this.emailValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }
    if (this._validationService.IsinValid(this.userEmailAddress)) {
      this.emailValid = false;
    }
  }

  saveEmail() {
    this.validateemail();
    if (this.emailForm.valid) {
      this.updateEmailModel.Email = this.userEmailAddress;
      this.updateEmailModel.ProspectUserId = this.prospectUserId;
      if (this.updateEmailModel.Email != null && this.updateEmailModel.Email != '') {
        this._dashboardService.saveEmailForProspects(this.updateEmailModel).subscribe(item => {
          if (item == true) {
            this.enableEmailEditField = false;
            this.prospectDetails.Email = this.userEmailAddress;
            this._toastService.addToast({ title: 'Success', msg: "Email saved successfully.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          }
          else {
            this._toastService.addToast({ title: 'Error', msg: "Please enter valid email address.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          }

        });
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: "Please update Prospect's Email ID.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    }
  }

  enableEmailEdit() {
    this.enableEmailEditField = true;
    this.emailValid = true;
    this.emailvalidation = "";
    this.userEmailAddress = '';
  }

  closeEmailEdit() {
    this.enableEmailEditField = false;
  }

  getFeedBackList() {
    this._commonService.getLookupsByTypeId(45).subscribe(response => {
      this.feedackList = response.map(o => {
        return {
          id: o.Id, name: o.Description
        };
      });
    });
  }

  FormatPhone(phone: string): string {
    if (!phone) return phone;

    const match = phone.match(/^(\d{10})(.*)/);
    if (match) {
      const phoneNumber = match[1];
      const remaining = match[2].trim();

      const formattedPhone = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
      return remaining ? `${formattedPhone} ${remaining}` : formattedPhone;
    }

    // Return original string if it doesn't start with 10 digits
    return phone;
  }

}
